import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'
// 验券接口
export function meituanVerify(data) {
  return request({
    url: `${apiConfig.ZY}/meiTuanGBCoupon/verify`,
    method: 'post',
    data
  })
}
// 列表
export function meituanList(data) {
  return request({
    url: `${apiConfig.ZY}/meiTuanGBCoupon/listCode`,
    method: 'post',
    data
  })
}
// 详情
export function queryVerifyResDetail(data) {
  return request({
    url: `${apiConfig.ZY}/meiTuanGBCoupon/queryVerifyRes`,
    method: 'post',
    data
  })
}
